import { render, staticRenderFns } from "./ComponentConteudo404.vue?vue&type=template&id=475cd06b&scoped=true&"
import script from "./ComponentConteudo404.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudo404.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudo404.vue?vue&type=style&index=0&id=475cd06b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475cd06b",
  null
  
)

export default component.exports